import { z } from "zod";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
    userId: z.string(),
    email: z.email(),
  }),
  response: z.object({
    refreshTokensRevoked: z.boolean(),
  }),
};
